<template>
  <div>
    <transition name="fade">
      <div
        class="show container"
        style="font-family: IRANSansX-Regular">
        <div class="row justify-content-md-center row-cols-1 mb-3">
          <div
            class="col-12 col-md-11 col-xl-7 mb-3 chart-form p-2"
            style="
              box-shadow: 0 2px 2px rgba(0, 0, 0, 0.16);
              border: 1px solid rgba(0, 0, 0, 0.175);
              border-radius: 8px;
              background: #fff;
            "
          >
            <ChartFormPrashnaPro
              @appViewUpdateData="updateLoadedData"
            />
          </div>

          <div class="w-100"/>

          <div class="w-100"/>

          <div class="col-12 col-md-11 col-xl-7 mr-auto mx-auto order-2 p-0 p-md-2">
            <PrashnaProChartInfo
              v-if="loadData['user']"
              :data="loadData"/>
          </div>

          <div
            v-if="loadData['user'] && loadData['analysis'] && loadData['is_save']"
            class="col-12 col-md-11 col-xl-7 mr-auto mx-auto mt-3 mt-md-0 order-3 p-0 p-md-2"
          >
            <div
              id="accordionPanelsStayOpenNotes"
              class="accordion"
              style="box-shadow: rgba(0, 0, 0, 0.16) 0px 2px 2px; border-radius: 8px"
            >
              <div class="accordion-item">
                <h2
                  id="panelsStayOpen-headingOne"
                  class="accordion-header">
                  <button
                    class="accordion-button accordion-custom-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#panelsStayOpen-collapseOne"
                    aria-expanded="true"
                    aria-controls="panelsStayOpen-collapseOne"
                  >
                    یادداشت‌های چارت
                  </button>
                </h2>
                <div
                  id="panelsStayOpen-collapseOne"
                  class="accordion-collapse collapse show"
                  aria-labelledby="panelsStayOpen-headingOne"
                >
                  <div class="accordion-body p-0">
                    <ChartNoteListPro
                      ref="chartNoteListRef"
                      :chart_id="loadData['link']"
                      :width="main_box_width"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="row justify-content-md-center"
          style="direction: ltr">
          <div
            ref="chart_box"
            class="col-12 col-md-11 col-lg-6 mr-auto mx-auto mb-3 p-0">
            <div
              v-if="loadData['bhava'] && loadData['graha']"
              id="accordionExample3"
              :style="`width: ${main_box_width}px; box-shadow: 0 2px 2px rgba(0, 0, 0, 0.16); border-radius: 7px;`"
              class="accordion mr-auto mx-auto"
            >
              <div class="accordion-item">
                <h2
                  id="headingTwo3"
                  class="accordion-header">
                  <button
                    class="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseTwo3"
                    aria-expanded="false"
                    aria-controls="collapseTwo3"
                  >
                    D1 - Rashi Chart
                  </button>
                </h2>
                <div
                  id="collapseTwo3"
                  class="accordion-collapse show"
                  aria-labelledby="headingTwo3"
                  data-bs-parent="#accordionExample3"
                >
                  <div class="accordion-body p-0">
                    <keep-alive>
                      <Chart
                        v-if="loadData['bhava'] && loadData['graha']"
                        :varga_number="'D1'"
                        :varga_name="'Rasi'"
                        :bhavas="loadData['bhava']"
                        :grahas="loadData['graha']"
                        :show_degree="true"
                        :is_main_chart="true"
                        :box_width="main_box_width - 5"
                        :bg_color="loadData['bg_chart']"
                        class="mr-auto mx-auto"
                      />
                    </keep-alive>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="loadData['user']"
            class="col-12 col-md-11 col-lg-6 mr-auto mx-auto mb-3 p-0"
          >
            <div
              v-if="loadData['bhava'] && loadData['graha']"
              id="accordionExample4"
              :style="`width: ${box_width}px; box-shadow: 0 2px 2px rgba(0, 0, 0, 0.16); border-radius: 7px;`"
              class="accordion mr-auto mx-auto"
            >
              <div class="accordion-item">
                <h2
                  id="headingTwo4"
                  class="accordion-header">
                  <button
                    class="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseTwo4"
                    aria-expanded="false"
                    aria-controls="collapseTwo4"
                    v-text="chart2Text"
                  />
                </h2>
                <div
                  id="collapseTwo4"
                  class="accordion-collapse show"
                  aria-labelledby="headingTwo4"
                  data-bs-parent="#accordionExample4"
                >
                  <div class="accordion-body p-0">
                    <keep-alive>
                      <Chart
                        v-if="loadData['varga']"
                        :varga_number="this.chart2Varga"
                        :varga_name="'Navamsa'"
                        :bhavas="loadData['varga']['D9']['bhava']"
                        :grahas="loadData['varga']['D9']['graha']"
                        :show_degree="false"
                        :is_main_chart="false"
                        :box_width="box_width - 5"
                        :bg_color="loadData['bg_chart']"
                        class="mr-auto mx-auto"
                      />
                    </keep-alive>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="loadData['user']"
          class="row justify-content-md-center"
          style="direction: ltr"
        >
          <div class="col-12 col-md-11 col-lg-6 mr-auto mx-auto mb-3 p-0">
            <div
              id="accordionPanelsStayOpenPlanetryPlanetry"
              :style="`width: ${main_box_width}px`"
              class="accordion mr-auto mx-auto"
              style="box-shadow: rgba(0, 0, 0, 0.16) 0px 2px 2px; border-radius: 8px"
            >
              <div class="accordion-item">
                <h2
                  id="panelsStayOpenPlanetry-headingOne"
                  class="accordion-header">
                  <button
                    class="accordion-button accordion-custom-butt on"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#panelsStayOpenPlanetry-collapseOne"
                    aria-expanded="true"
                    aria-controls="panelsStayOpenPlanetry-collapseOne"
                  >
                    جدول سیاره‌ای
                  </button>
                </h2>
                <div
                  id="panelsStayOpenPlanetry-collapseOne"
                  class="accordion-collapse collapse show"
                  aria-labelledby="panelsStayOpenPlanetry-headingOne"
                >
                  <div
                    class="accordion-body p-1"
                    style="background-color: #f9f9f9; overflow-y: scroll"
                  >
                    <PlanetryTablePro
                      :grahas="loadData['graha']"
                      :lagna="loadData['lagna']"
                      :box_width="main_box_width"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-11 col-lg-6 mr-auto mx-auto mb-3 p-0">
            <div
              id="accordionPanelsStayOpenDashaDasha"
              :style="`width: ${box_width}px`"
              class="accordion mr-auto mx-auto"
              style="box-shadow: rgba(0, 0, 0, 0.16) 0px 2px 2px; border-radius: 8px"
            >
              <div class="accordion-item">
                <h2
                  id="panelsStayOpenDasha-headingOne"
                  class="accordion-header">
                  <button
                    class="accordion-button accordion-custom-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#panelsStayOpenDasha-collapseOne"
                    aria-expanded="true"
                    aria-controls="panelsStayOpenDasha-collapseOne"
                  >
                    دوره‌های سیاره‌ای
                  </button>
                </h2>
                <div
                  id="panelsStayOpenDasha-collapseOne"
                  class="accordion-collapse collapse show"
                  aria-labelledby="panelsStayOpenDasha-headingOne"
                >
                  <div
                    class="accordion-body p-1"
                    style="background-color: #f9f9f9">
                    <DashaTable
                      v-if="loadData['dasha']"
                      :birthdate="loadData['user']['datetime']"
                      :date_type="loadData['user']['date_type']"
                      :data="loadData['dasha']"
                      :box_width="box_width"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="loadData['varga']"
          class="row justify-content-md-center"
          style="direction: ltr"
        >
          <div class="col-12 col-md-11 col-lg-6 mr-auto mx-auto mb-3 p-0">
            <div
              v-if="loadData['varga']"
              id="accordionPanelsSMTransit3rd"
              :style="`width: ${main_box_width}px; box-shadow: 0 2px 2px rgba(0, 0, 0, 0.16); border-radius: 7px;`"
              class="accordion mr-auto mx-auto"
            >
              <div class="accordion-item">
                <h2
                  id="panelsSMT-headingOne"
                  class="accordion-header">
                  <button
                    class="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#panelsSMT-collapseOne"
                    aria-expanded="true"
                    aria-controls="panelsSMT-collapseOne"
                  >
                    چارتِ ترانزیت
                  </button>
                </h2>
                <div
                  id="panelsSMT-collapseOne"
                  class="accordion-collapse collapse show"
                  style="box-shadow: 0 2px 2px rgba(0, 0, 0, 0.16); border-radius: 7px"
                  aria-labelledby="panelsSMT-headingOne"
                >
                  <div
                    v-if="loadData['varga']['transit']"
                    class="accordion-body p-0">

                    <ChartTransit
                      v-if="loadData['varga']['transit']"
                      :varga_number="'T'"
                      :varga_name="'Transit Chart'"
                      :bhavas="loadData['varga']['transit']['bhava']"
                      :display_bhavas="loadData['varga']['transit']['bhava']"
                      :grahas="loadData['varga']['transit']['graha']"
                      :show_degree="true"
                      :is_main_chart="false"
                      :box_width="main_box_width - 5"
                      :bg_color="loadData['bg_chart']"
                      class="mr-auto mx-auto"
                    />

                  </div>

                  <TransitForm
                    :t_year.sync="t_year"
                    :t_month.sync="t_month"
                    :t_day.sync="t_day"
                    :t_hour.sync="t_hour"
                    :t_min.sync="t_min"
                    :timezone="loadData['user']['timezone']"
                    :t_sec.sync="t_sec"
                    :t_date_type.sync="loadData['user']['date_type']"
                    :box_width="main_box_width - 5"
                    @submitTransitData="getTransitChart"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <Loading :is-loading="isLoading" />
  </div>
</template>

<script>
import Chart from '../components/Chart.vue'

import ChartTransit from '../components/ChartTransit.vue'
import ChartListPro from '../components/ChartListPro.vue'
import ChartNoteListPro from '../components/ChartNoteListPro.vue'
import PrashnaProChartInfo from '../components/PrashnaProChartInfo.vue'
import ShareLinkFree from '../components/ShareLinkFree.vue'
import ChartFormPrashnaPro from '../components/ChartFormPrashnaPro.vue'
import PlanetryTablePro from '../components/PlanetryTablePro.vue'
import DashaTable from '../components/DashaTable.vue'
import HelperLib from '../components/helper'
import HoraLogo from '../components/HoraLogo.vue'
import NoteListPro from '../components/NoteListPro.vue'
import DatePicker from '../components/DatePicker.vue'
import TimePicker from '../components/TimePicker.vue'
import TransitForm from '../components/TransitForm.vue'
import Loading from '../components/Loading.vue'
import ApiService from '../service/api'
import moment from 'jalali-moment'

export default {
  name: 'PrashnaView',
  components: {
    Chart,
    ChartListPro,
    PrashnaProChartInfo,
    ChartFormPrashnaPro,
    PlanetryTablePro,
    DashaTable,
    ChartTransit,
    HelperLib,
    HoraLogo,
    ShareLinkFree,
    DatePicker,
    TimePicker,
    TransitForm,
    Loading,
    NoteListPro,
    ChartNoteListPro,
    ApiService
  },
  data () {
    return {
      isLoading: false,
      chart2Varga: 'D9',
      chart3Varga: 'D30',
      chart2Text: 'D9 - Navamsa Chart',
      chart3Text: 'D30 - Trimshamsha',
      link_clicked: false,
      loadData: [],
      box_width: null,
      main_box_width: null,
      pages: {
        is_calculate: true,
        is_charts: false,
        is_notes: false
      },
      t_year: null,
      t_month: null,
      t_day: null,
      t_hour: null,
      t_min: null,
      t_sec: null
    }
  },
  mounted: function () {
    this.adjustBoxesWidth()
  },
  methods: {
    getTransitChart (is_submit, year, month, day, hour, min, sec) {
      // console.log(is_submit, year, month, day, hour, min, sec);
      if (is_submit) {
        const id = this.loadData['link']
        const request = {
          hash_id: id,
          t_year: year,
          t_month: month,
          t_day: day,
          t_hour: hour,
          t_min: min,
          t_sec: sec
        }

        this.isLoading = true
        ApiService.getTransit(request).then((response) => {
          // console.log(response);
          this.loadData['varga']['transit'] = response['data']['varga']['transit']
          // console.log(this.loadData["varga"]["transit"])
          // this.loadData["varga"]["transit"]["display_bhavas"] = this.loadData["bhava"];
          this.isLoading = false
        })
      }
    },
    adjustBoxesWidth () {
      if (screen.width > 960) {
        // DESKTOP
        this.box_width = (this.$refs.chart_box.clientWidth * 92) / 100
        this.main_box_width = (this.$refs.chart_box.clientWidth * 97) / 100
      } else {
        this.box_width = (this.$refs.chart_box.clientWidth * 100) / 100
        this.main_box_width = this.box_width
      }
    },

    isMobile () {
      return HelperLib.isMobile()
    },
    showMobileViewChartHeader (width) {
      return `
      font-size: 12px; 
      border-radius: 8px; 
      width: ${width}px;  
      line-height: 10px; 
      color: #000;`
    },
    formatLocation (user) {
      let lonDir = user['longitude'] < 0 ? 'W' : 'E'
      let latDir = user['latitude'] < 0 ? 'S' : 'N'
      let out =
        user['latitude_dms']['deg'] +
        ' ' +
        latDir +
        ' ' +
        user['latitude_dms']['min'] +
        ' - '
      out +=
        user['longitude_dms']['deg'] + ' ' + lonDir + ' ' + user['longitude_dms']['min']
      return out
    },
    formatLagnaText (rashi) {
      return HelperLib.rashiToPersianText(rashi)
    },
    getSignLink (data) {
      var lagna = HelperLib.rashiToPersianText(data['lagna']['Lg']['rashi'])
      return `${lagna[1]}`
    },
    updateLoadedData (data) {
      this.isLoading = true
      this.loadData = data
      const now = moment().utcOffset(this.loadData['user']['timezone'])
      if (this.loadData['user']['date_type'] == 'jalali') {
        this.t_year = now.format('jYYYY')
        this.t_month = now.format('jMM')
        this.t_day = now.format('jDD')
        this.t_hour = now.format('HH')
        this.t_min = now.format('mm')
        this.t_sec = now.format('ss')
      } else {
        this.t_year = now.format('YYYY')
        this.t_month = now.format('MM')
        this.t_day = now.format('DD')
        this.t_hour = now.format('HH')
        this.t_min = now.format('mm')
        this.t_sec = now.format('ss')
      }

      // console.log(
      //   this.t_year,
      //   this.t_month,
      //   this.t_day,
      //   this.t_hour,
      //   this.t_min,
      //   this.t_sec
      // );

      const id = this.loadData['link']
      const request = {
        hash_id: id,
        t_year: this.t_year,
        t_month: this.t_month,
        t_day: this.t_day,
        t_hour: this.t_hour,
        t_min: this.t_min,
        t_sec: this.t_sec
      }

      ApiService.getTransit(request).then((response) => {
        this.loadData['varga']['transit'] = response['data']['varga']['transit']
        // this.loadData["varga"]["transit"]["display_bhavas"] = response["data"]["varga"]["transit"]['bhava'];
        this.isLoading = false
      })
    }
  }
}
</script>

<style scoped>
.custom-accordion-header {
  background-color: #f2f2f2;
  color: #333;
  border: 1px solid #ccc;
}

.custom-accordion-header:hover {
  background-color: #e6e6e6;
}

.custom-accordion-header.active {
  background-color: #ddd;
}
.accordion-button-custom:not(.collapsed) {
  color: #000000;
  font-weight: bold;
  background-color: #fff;
  box-shadow: inset 0 -1px 0 rgb(0 0 0 / 13%);
}

* {
  padding: 0px;
  margin: 0px;
}
.now-analysis {
  direction: rtl;
  text-align: right;
  background-color: rgba(255, 253, 231, 0.5);
  border-radius: 0.25rem;
  font-size: 16px;
  color: black;
  border: 1px solid rgb(242, 242, 242);
}
.loading {
  left: 0px;
  top: 0px;
  right: 0px;
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 100;
  background: rgba(255, 255, 255, 0.8);
}
</style>
<!-- <style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style> -->
